import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import App from './App';
import { isPrerendered } from './utils/env';

const container = document.getElementById('root') as HTMLElement;
const app = (
	<React.StrictMode>
		<App />
	</React.StrictMode>
);

// Pages built by scripts/prerender.mjs ship with their markup already inside
// #root — hydrate it instead of throwing it away and rendering from scratch.
if (isPrerendered) {
	hydrateRoot(container, app);
} else {
	createRoot(container).render(app);
}
